import React, { useState } from 'react';

export const PageConfigurationContext:any = React.createContext({});
export const PageConfigurationContextProvider = (props: { children: React.ReactNode }) => {
	const [PageConfiguration, setPageConfiguration] = useState({});
	return (
		<PageConfigurationContext.Provider
			value={{
				data: PageConfiguration,
				set: (e) => {
					setPageConfiguration(e);
				},
				setPageConfiguration:setPageConfiguration
			}}
		>
			{props.children}
		</PageConfigurationContext.Provider>
	);

};